import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import reducer from './reducers/index';
import { composeWithDevTools } from 'redux-devtools-extension';

const middleware = [thunk];

if (process.env.NODE_ENV === `development`) {
  const { logger } = require(`redux-logger`);

  middleware.push(logger);
}

export default createStore(
  reducer,
  composeWithDevTools(applyMiddleware(...middleware))
)




// WEBPACK FOOTER //
// ./src/store.js